import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import ErrorComponent from '../../components/ErrorComponent'
import ClientMenu from './ClientMenu'
import { CheckClientExistService, CreateClientService, SendClientTextMessage, UpdateClientService, UpdateVisitClientService, ValidateClientDataInRealDBService } from '../../services/ClientServices'
import { CreateClientAttachmentService, CreateClientAttachmentSessionService, CreateClientChatService, CreateClientSessionChatService, CreateClientTemplateService, GetClientChatService } from '../../services/ClientChatServices'
import moment from 'moment'
import { DatePicker, Modal, Select } from 'antd'
import { GetSearchService } from '../../services/AuthServices'
import { GetCityListService } from '../../services/admin/CityListServices'
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { useSelector } from 'react-redux'
import AudioPlayer from '../../components/AudioPlayer'
import FileDownloadCard from '../../components/FileDownloadCard'
import { CgAttachment } from "react-icons/cg";
import ImageDownloadCard from '../../components/ImageDownloadCard'
import AudioRecorder from '../../components/AudioRecorder'
import { LuUpload } from "react-icons/lu";
import { MdOutlineTimer } from "react-icons/md";
import { GetAllTemplateService } from '../../services/TemplateServices'
import dayjs from 'dayjs';
import { GetTeacherSearchService } from '../../services/class_booking/TeacherServices'

function ClientListCE({passData}) {

  const fileInputRef = useRef(null)
  const roles = useSelector(state=>state.Auth.roles)

  const messagesEndRef = useRef(null);

  const templateMessage = [{label:'Final Message',value:'finalning'},{label:'Welcome Message',value:'welcomemsg11'},]
  const customerType = [{label:'New',value:'New'},{label:'Duplicate',value:'Duplicate'},{label:'Already Exist With Another No',value:'Already Exist With Another No'}]

  const [call_followup,setcall_followup] = useState({message:'',customer_call:'',remarks:'',called_date_time:''})
  const [sessionInfo,setsessionInfo] = useState({session:false,last_message_received:{}})
  const [loader,setloader] = useState(false)
  const [data, setdata] = useState({ name: '', mobile: '', email: '',interested:false,subscribed:false,app_installed:false,handled_by:[],customer_type:'',remarks:'',template_message:'',campaign_info:{medium_of_study:'',enter_class:''},subscribed_and_expired:false,demo_booked:false,demo_booked_and_attended:false,subscribe_batch:false,subscribe_start_date:'',subscribe_end_date:'',subscribe_start_date1:'',subscribe_end_date1:''});
  const [error, seterror] = useState({name: '', mobile: '', email: '',interested:'',subscribed:'',handled_by:'',customer_type:'',remarks:'',template_message:'',campaign_info:{medium_of_study:'',enter_class:''},subscribed_and_expired:'',demo_booked:'',demo_booked_and_attended:'',subscribe_batch:'',subscribe_start_date:'',subscribe_end_date:'',subscribe_start_date1:'',subscribe_end_date1:''});
  const [modal,setmodal] = useState(false)
  const [modal1,setmodal1] = useState(false)
  const [user,setuser] = useState([])
  const [teacher,setteacher] = useState([])
  const [chatType,setchatType] = useState('Session')
  const [messages,setmessages] = useState({})
  const [messageInfo,setmessageInfo] = useState({message:'',error:''})
  const [page,setpage] = useState(1)
  const [search,setsearch] = useState({text:'',from_date:'',to_date:'',from_date1:'',to_date1:''})
  const [timeLeft, setTimeLeft] = useState({ hours: 24, minutes: 0 });

  const [templateMessageArr, settemplateMessageArr] = useState([])

  const [checkContactExist,setcheckContactExist] = useState({})

  const canEditCity = roles?.includes('admin') || roles?.includes('salesExecutive')
  const [cityOptions, setcityOptions] = useState([])

  useEffect(()=>{
    async function loadCities(){
      const response = await GetCityListService()
      const cities = (response?.data?.datas?.[0]?.datas || '').split(',').map((c)=>c.trim()).filter(Boolean)
      setcityOptions(cities?.map((c)=>({label:c,value:c})))
    }
    loadCities()
  },[])

  const navigate = useNavigate();


  const path = useLocation();

  // console.log("path",path)

  let state = path?.pathname !== '/dashboard/chat_window' ? path.state : passData?.customer
  let showEdit = path?.pathname !== '/dashboard/chat_window' ? true : false
 
  async function searchemployee(e){
    const response = await GetSearchService(e,1)
    let arr = []
    response?.data?.datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id})
    })
    setuser(arr)
  }

  async function searchTeacher(e){
    const response = await GetTeacherSearchService(e,1,'Counsellor')
    let arr = []
    response?.data?.datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id})
    })
    setteacher(arr)
  }

  console.log("teacher",teacher)

  useEffect(() => {
  messagesEndRef.current?.scrollIntoView({
    behavior: "smooth",
    block: "end",
  });
}, [messages?.datas]);

console.log("messages",state)

  useEffect(() => {
    if (state?._id !== null && state?._id !== undefined) {
      if(!state?.visited){
        updateVisit()
      }
      let arr = []
      let arr1 = []
      state.handled_by.forEach((d)=>arr.push({label:d.name,value:d._id}))
      state.teacher_handled_by.forEach((d)=>arr1.push({label:d.name,value:d._id}))
      let oldData = {...state,handled_by:arr,teacher_handled_by:arr1}
      if(oldData?.subscribe_start_date && oldData?.subscribe_end_date){
        oldData['subscribe_start_date1'] = oldData?.subscribe_start_date
        oldData['subscribe_end_date1'] = oldData?.subscribe_end_date
        oldData['subscribe_start_date'] = oldData?.subscribe_start_date
        oldData['subscribe_end_date'] = oldData?.subscribe_end_date
      }
      setdata({ ...data, ...oldData })
      getMessage()

    }

  }, [state,page])



  useEffect(() => {
  const calculateTimeLeft = () => {
    if (sessionInfo?.last_message_received?.createdAt) {
      const startDate = new Date(sessionInfo.last_message_received.createdAt);
      const now = new Date();

      const totalMs = 24 * 60 * 60 * 1000;
      const elapsedMs = now - startDate;

      const remainingMs = Math.max(totalMs - elapsedMs, 0);

      const hours = Math.floor(remainingMs / (1000 * 60 * 60));
      const minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));

      setTimeLeft({ hours, minutes });
    } else {
      setTimeLeft({ hours: 0, minutes: 0 });
    }
  };

  calculateTimeLeft();
  const interval = setInterval(calculateTimeLeft, 60000);
  return () => clearInterval(interval);
  }, [sessionInfo?.last_message_received?.createdAt]);

  useEffect(()=>{
     getTemplateMessage()
  },[])

  async function getTemplateMessage(){
      const response = await GetAllTemplateService()
      let arr = []
      response?.data?.datas?.forEach((d)=>{
        arr?.push({label:d?.label,value:d?._id,data:d})
      })
      settemplateMessageArr(arr)
    }
  

  async function updateVisit() {
    await UpdateVisitClientService({},state?._id) 
  }

  async function handlechange(e) {
    let {name,value} = e.target
    if(name === 'mobile'){
      if(value.length === 10){
         const response = await CheckClientExistService({mobile:value})
         setcheckContactExist(response?.data)
      }
    }
    setdata({ ...data, [name]: value })
    seterror({ ...error, [name]: '' })
  }

  console.log("checkContactExist",checkContactExist)

  function handlechange1(e) {
    const { name, value } = e.target;

    console.log("name",name)
    console.log("value",value)

    setdata(prev => ({
      ...prev,
      campaign_info: {
        ...(prev.campaign_info || {}),
        [name]: value
      }
    }));

    seterror(prev => ({
      ...prev,
      campaign_info: {
        ...(prev.campaign_info || {}),
        [name]: ''
      }
    }));
  }

  async function submitform() {
    if (!data.name) {
      seterror({ ...error, name: 'Name field is required *' })
    }else if (!data.mobile) {
      seterror({ ...error, mobile: 'Mobile field is required *' })
    }else {
      let sendData = { ...data }
      let arr = []
      let arr1 = []
      if(!sendData?.mode_type){
        delete sendData.mode_type
      }
      data?.handled_by?.map((d)=>arr.push(d.value))
      if(arr.length > 0){
        sendData['handled_by'] = arr
      }else{
        delete sendData.handled_by
      }

      data?.teacher_handled_by?.map((d)=>arr1.push(d.value))
      if(arr1.length > 0){
        sendData['teacher_handled_by'] = arr1
      }else{
        delete sendData.teacher_handled_by
      }

      if(data?.subscribe_start_date1 && data?.subscribe_end_date1){
        sendData['subscribe_start_date'] = data?.subscribe_start_date1
        sendData['subscribe_end_date'] = data?.subscribe_end_date1
      }else{
        delete sendData.subscribe_start_date
        delete sendData.subscribe_end_date
      }


      if (state?._id === undefined || state?._id === null) {
        
        const response = await CreateClientService(sendData)
        if (response.status === 201) {
          resetform()
          toast.success('Client Created Successfully')
        }
        if (response.status === 422) {
          if (response?.data?.errors?.title) {
            seterror({ ...error, title: response?.data?.errors?.title })
          }
        }
      } else {
        sendData["id"] = state?._id
        const response = await UpdateClientService(sendData, state?._id)
        if (response.status === 200) {
          // resetform()
          navigate(-1)
          toast.success('Client Updated Successfully')
        }
        if (response.status === 422) {
          if (response?.data?.errors?.title) {
            seterror({ ...error, title: response?.data?.errors?.title })
          }
        }
      }
    }
  }

  async function validateData(){
    const response = await ValidateClientDataInRealDBService(state?._id)
    navigate(-1)
    toast.success("New Changes will be refelected if anything exist")
  }

  async function resetform() {
    setdata({ name: '', mobile: '', email: '',interested:false,subscribed:false,app_installed:false,handled_by:[],customer_type:'',remarks:'',campaign_info:{medium_of_study:'',enter_class:''} })
    seterror({ name: '', mobile: '', email: '',interested:false,subscribed:false,handled_by:[],customer_type:'',remarks:'',campaign_info:{medium_of_study:'',enter_class:''} })

  }

  function handleChange1(e){
    setmessageInfo({...messageInfo,message:e.target.value,error:''})
  }

  function handleChange2(e){
    setcall_followup({...call_followup,message:e.target.value,error:''})
  }

  async function submitMessage(){
    if(!messageInfo?.message){
      setmessageInfo({...messageInfo,error:'Message Field is required!'})
    }else{

      try{
        let passData = {
          message:messageInfo?.message,
          customer:state?._id,
          chat_type:'SalesUser',
          type:'text'
        }
        
        if(chatType == 'Template'){
          const response = await CreateClientChatService(passData)
          console.log("response",response)
          if(response.status === 201){
            getMessage()
            setmessageInfo({message:'',error:''})
            toast.success("Client Message Shared!")
          }
        }else{
          const response = await CreateClientSessionChatService(passData)
          console.log("response",response)
          if(response.status === 201){
            getMessage()
            setmessageInfo({message:'',error:''})
            toast.success("Client Message Shared!")
          }
        }
      }catch(err){
        console.log("err",err)
          toast.error(err?.response?.data)
      }
    }
  }

  async function getMessage() {
    await UpdateClientService({}, state?._id)
    const response = await GetClientChatService(state?._id,page,search?.text,search?.from_date1,search?.to_date1)
    let customer_last_sent_message = response?.data?.customer_last_sent_message
    const createdAt = new Date(customer_last_sent_message?.createdAt);
    const now = new Date();
    const diffInMs = now - createdAt;
    const diffInHours = diffInMs / (1000 * 60 * 60);

    setsessionInfo({
      last_message_received:customer_last_sent_message,
      session:diffInHours.toFixed(2) < 24 ? true : false
    })

    diffInHours.toFixed(2) < 24 ? setchatType('Session') : setchatType('Template')
    setmessages(response?.data)
  }


  async function handleSelect(e,e1){
    if(e1 === 'handled_by'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(user?.find((r)=>r?.value === ele))
      })
      setdata({...data,handled_by:arr})
      seterror({...error,roles:''})
    }
    if(e1 === 'teacher_handled_by'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(teacher?.find((r)=>r?.value === ele))
      })
      setdata({...data,teacher_handled_by:arr})
      seterror({...error,roles:''})
    }
    if(e1 === 'customer_type'){
      setdata({...data,customer_type:e})
      seterror({...error,customer_type:''})
    }

    if(e1 === 'mode_type'){
      setdata({...data,mode_type:e})
      seterror({...error,mode_type:''})
    }
  }

  function openFilePicker(){
    fileInputRef.current?.click()
  }

  async function  handleFileChange(e){
    const file = e.target.files[0]
    e.target.value = null; 
    if (!file) return;
    setloader(true)

    const maxSizeInMB = 15;
    const fileSize = file.size / (1024 * 1024)

    if (fileSize.toFixed(2) < maxSizeInMB) {
      if (file ) {
      const fd = new FormData()
      fd.append('file',file)
      fd.append('type',"image")
      fd.append('customer',state?._id)
      
      if(chatType == 'Template'){
        fd.append('message',messageInfo?.message??'-')
        const response = await CreateClientAttachmentService(fd)
        if(response){
          setloader(false)
          setmessageInfo({message:'',error:''})
          toast.success("Client Message Shared!")
          getMessage()
        }
      }else{
        try{
          const response = await CreateClientAttachmentSessionService(fd)
          setloader(false)
          if(response){
            setmessageInfo({message:'',error:''})
            toast.success("Client Message Shared!")
            getMessage()
          }
        }catch(err){
          setloader(false)
          toast.error(err?.data?.message)
        }
      }
    }
      // toast.success("File Size validated")
    }else{
      setloader(false)
      toast.error("File Size should be less than 15 MB")
    }
    
  }

  async function submitTemplate() {
    if(!data?.template_message){
      seterror({...error,template_message:'This Filed is required*'})
    }else{
      let passData = {
        customer:state?._id,
        template:data?.template_message?.value,
      }

      if(data?.template_message?.data?.variables?.length > 0){
        data?.template_message?.data?.variables?.forEach((v)=>{
          passData[v.key] = v.value
        })
      }

      const response = await CreateClientTemplateService(passData)
      if(response?.status === 400 || response?.status === 201){
          setmessageInfo({message:'',error:''})
          setdata({...data,template_message:''})
          toast.success("Client Message Shared!")
          getMessage()
        }
      setmodal(false)
    }
  }

  async function checkmessageText() {
    const response = await SendClientTextMessage()
  }

  const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12; // convert 0 -> 12
    return `${h}:${minutes} ${ampm}`;
  };


  const mode_type = ['Online', 'Offline']
 
 
  return (
    <div className='md:flex w-full md:max-h-screen min-h-[100vh]'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Send Template message</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>Use the below form to send the template message</h6>
          
          <h6 className='text-[11px] mb-1 mt-2 font-[700]'>Select Template</h6>
          <Select 
            placeholder={'Type'} 
            value={data?.template_message == '' ? null : data?.template_message}
            options={templateMessageArr}
            bordered={false}
            onChange={(e)=>setdata({...data,template_message:templateMessageArr?.find((t)=>t.value === e)})}
            className='border rounded-[6px] w-[100%] mr-1 border-slate-300'
          /> 
          <ErrorComponent  error={error?.template_message} />
          
          {data?.template_message?.data?.variables?.length > 0 && 
            <div className='mt-4 mb-2'>
              {data?.template_message?.data?.variables?.map((v, i) => ( 
                <div key={i} className='flex flex-col mb-2'>
                  <h6 className='text-[11px] font-[600]'>{v.label}</h6>
                  <input
                    className='border border-slate-300 focus:outline-none px-2 py-1 text-[12px] rounded'
                    placeholder={v.key}
                    value={v.value}
                    onChange={e => {
                      const newVars = [...data.template_message.data.variables]
                      newVars[i].value = e.target.value
                      setdata({ ...data, template_message: {...data.template_message, data: {...data.template_message.data, variables: newVars}} })
                    }}
                    />   
                    </div>
              ))}
            </div>  
          }


          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => submitTemplate()} />
            </div>
          </div>
        </div>
      </Modal>


      <Modal
        keepMounted
        open={modal1}
        onClose={() => setmodal1(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Create Client Followup</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>Use the below form to create a client followup message</h6>
          

           <TextAreaInput1
            label={'Message'}
            variant="standard"
            name="message"
            type="text"
            error={call_followup.message}
            value={call_followup.message}
            handlechange={handleChange2}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />   

        
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal1(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => submitTemplate()} />
            </div>
          </div>
        </div>
      </Modal>
      
      {loader &&
      <div className='absolute right-2 top-4'>
        <div className='bg-[#de9f19] animate-bounce flex items-center rounded p-2 text-[11px]'>
           <LuUpload />
           <h6 className='ml-2 font-[800]'>Uploading File</h6>
        </div>
      </div>}

     
     {showEdit &&
      <div>
      <ClientMenu />
      </div>} 
      <div className='mb-5 w-full h-full'>
      <div className='md:flex w-full'>  
        {showEdit && <div className='sm:w-full lg:w-[350px] px-4 pt-5' >


          <GoBack />

          {/* <AudioRecorder /> */}



          <h6 className='font-bold'>{(state?._id !== null && state?._id !== undefined) ? 'Edit' : 'Add'} Client Info</h6>
          <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b>Client Entry details</b> assign to you!.</h6>

          {/* <AudioRecorderComponent /> */}

          <div className='flex my-2 flex-wrap'>
          {state?.app_installed && <h6 className='bg-green-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'App Installed'}</h6>}
          {state?.subscribed && <h6 className='bg-yellow-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Subscribed'}</h6>}
          {state?.demo_call_completed && <h6 className='bg-red-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Demo Watched'}</h6>}
          </div> 

          <TextInput
            mandatory={true}
            label={'Name'}
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />

          <TextInput
            mandatory={true}
            label={'Mobile'}
            variant="standard"
            name="mobile"
            type="text"
            // readOnly={(roles?.includes('admin') || state?._id == undefined)}
            error={error.mobile}
            value={data.mobile}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />  

            {data?.mobile?.length === 10 &&
              checkContactExist?.exists &&
              checkContactExist?.data?.mobile === data?.mobile && (
                <div className="bg-slate-100 text-[11px] p-1 px-2 mt-2 rounded-md">
                  <h6>Client Already Exists With Number: {checkContactExist?.data?.mobile}</h6>

                  <h6 className="font-[700] mt-1">Client Info</h6>

                  <div className="bg-red-200 p-2 rounded-md mt-1 space-y-0">
                    <h6>Name: <span className='font-[700]'>{checkContactExist?.data?.name || "N/A"}</span></h6>
                    <h6>Source: <span className='font-[700]'>{checkContactExist?.data?.source || "N/A"}</span></h6>

                    {/* Handled By */}
                    {checkContactExist?.data?.handled_by && (
                      <h6>
                        Handled By: <span className='font-[700]'>{checkContactExist?.data?.handled_by[0]?.name || "N/A"}</span>
                      </h6>
                    )}
                  </div>
                </div>
            )}

            {/* <ButtonFilledAutoWidth btnName={"Check Text Message"} onClick={checkmessageText} /> */}

          <TextInput
            label={'Email'}
            variant="standard"
            name="email"
            type="text"
            error={error.email}
            value={data.email}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />

            {canEditCity ?
            <div>
             <h6 className='text-[11px] mb-1 mt-2'>City </h6>
                <Select
                  showSearch
                  value={data.city || null}
                  options={cityOptions}
                  filterOption={(input,option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  onChange={(v)=>{setdata({...data,city:v});seterror({...error,city:''})}}
                  placeholder=""
                  bordered={false}
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div>
            : data?.city &&
            <h6 className='text-[11px] mb-1 mt-2'>City : <b>{data.city}</b></h6>}

             <TextInput
            mandatory={true}
            label={'Language (KN/EN)'}
            variant="standard"
            name="medium_of_study"
            type="text"
            error={error.campaign_info.medium_of_study}
            value={data.campaign_info.medium_of_study}
            handlechange={handlechange1}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />  


             <TextInput
            mandatory={true}
            label={'Class Standard'}
            variant="standard"
            name="enter_class"
            type="text"
            error={error.campaign_info.enter_class}
            value={data.campaign_info.enter_class}
            handlechange={handlechange1}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />   

            {roles?.includes('admin') &&
            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Handling By </h6>
              
                <Select
                  showSearch
                  value={data.handled_by} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  mode="multiple"
                  onSearch={searchemployee}
                  onChange={(e)=>handleSelect(e,'handled_by')} 
                  options={user} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div>}   

             {roles?.includes('admin') &&
            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Teacher Handling By </h6>
              
                <Select
                  showSearch
                  value={data.teacher_handled_by} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  mode="multiple"
                  onSearch={searchTeacher}
                  onChange={(e)=>handleSelect(e,'teacher_handled_by')} 
                  options={teacher} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div>} 
  
          <ErrorComponent error={error?.type} /> 

           <div>
             <h6 className='text-[11px] mb-1 mt-2'>Customer Type </h6>
              
                <Select
                  showSearch
                  value={data.customer_type} 
                  filterOption={false}
                  bordered={false}
                  onChange={(e)=>handleSelect(e,'customer_type')} 
                  options={customerType} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div>
          
        

          <div onClick={()=>setdata({...data,interested:!data.interested})} className='flex items-center mt-2 mr-2'>
            {/*  */}
            {data?.interested ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
            <h6 className="text-[10px] font-[600] ml-1">Interested</h6> 
          </div> 

{/* onClick={()=>setdata({...data,subscribed:!data.subscribed})} */}
           <div  className='flex items-center opacity-40 mt-2 mr-2'>
            {/* onClick={()=>setdata({...data,approval_required:!data.approval_required})} */}
            {data?.subscribed ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
            <h6 className="text-[10px] font-[600] ml-1">Subscribed</h6> 
          </div> 

           <div onClick={()=>setdata({...data,call_not_recieved:!data.call_not_recieved})} className='flex items-center mt-2 mr-2'>
            {data?.call_not_recieved ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
            <h6 className="text-[10px] font-[600] ml-1">Call Not Recieved</h6> 
          </div> 

{/* onClick={()=>setdata({...data,app_installed:!data.app_installed})} */}
            <div  className='flex items-center opacity-40 mt-2 mr-2'>
            {data?.app_installed ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
            <h6 className="text-[10px] font-[600] ml-1">App Installed</h6> 
          </div> 


          <TextAreaInput1 
          label={'Remarks'}
            variant="standard"
            name="remarks"
            type="text"
            error={error.remarks}
            value={data.remarks}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />



          {roles?.includes('admin') &&
            <>
            {(state?._id !== null && state?._id !== undefined) && 
             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Mode Type </h6>
                <Select
                  showSearch
                  value={data.mode_type} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={mode_type?.map((c)=>({label:c,value:c}))}
                  onChange={(e)=>handleSelect(e,'mode_type')}
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div>}
          {data?.personal_training_subscription_teacher_batch && <div className='border p-2 mt-2'>
            <h6 className='text-[11px] font-[800] my-2'>Batch Subscribed Info</h6>
            <h6 className='text-[12px]'>Teacher Name : <span className='font-[800]'>{data?.personal_training_subscription_teacher_batch?.teacher_name}</span></h6>
            <h6 className='text-[12px]'>Slot : <span className='font-[800]'>{formatTo12Hour(data?.personal_training_subscription_teacher_batch?.batch_info?.start_time)} - {formatTo12Hour(data?.personal_training_subscription_teacher_batch?.batch_info?.end_time)}</span></h6>
          </div>}

          <div className='flex flex-wrap'>

           
          <div  className='flex items-center mt-2 mr-2' onClick={()=>setdata({...data,subscribed_and_expired:!data.subscribed_and_expired})} >
            {data?.subscribed_and_expired ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
            <h6 className="text-[10px] font-[600] ml-1">Subscribed And Expired</h6> 
          </div> 

          <div  className='flex items-center mt-2 mr-2' onClick={()=>setdata({...data,demo_booked:!data.demo_booked})} >
            {data?.demo_booked ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
            <h6 className="text-[10px] font-[600] ml-1">Demo Booked</h6> 
          </div> 

          <div  className='flex items-center mt-2 mr-2' onClick={()=>setdata({...data,demo_booked_and_attended:!data.demo_booked_and_attended})} >
            {data?.demo_booked_and_attended ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
            <h6 className="text-[10px] font-[600] ml-1">Demo Booked And Attended</h6> 
          </div> 

           <div  className='flex items-center mt-2 mr-2' onClick={()=>setdata({...data,subscribe_batch:!data.subscribe_batch})} >
            {data?.subscribe_batch ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
            <h6 className="text-[10px] font-[600] ml-1">Subscribe Batch</h6> 
          </div> 

          <div>
            <h6 className='text-[11px] font-[600] my-2'>Subscribe Date Period</h6>
             <DatePicker style={{ fontSize: '11px' }} ampm={false} placeholder='Start  Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={data?.subscribe_start_date ? dayjs(data.subscribe_start_date) : null}  onChange={(v, v1) => {setdata({ ...data, subscribe_start_date: v, subscribe_start_date1: v1 }) }} />
             <DatePicker style={{ fontSize: '11px' }} ampm={false} placeholder='End Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={data?.subscribe_end_date ? dayjs(data.subscribe_end_date) : null}  onChange={(v, v1) => {setdata({ ...data, subscribe_end_date: v, subscribe_end_date1: v1 }) }} />
          </div>  

          </div>
          </>}


         
        <div className='mt-4 flex'>
          {(state?._id !== null && state?._id !== undefined) && 
          <>
          <ButtonOutlinedAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "CHECK STATUS" : "CHECK STATUS"} onClick={validateData} />
          <h6 className='min-w-[10px]'></h6>
          </>}
          <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE" : "ADD"} onClick={submitform} />
        </div>


        {state?.source === 'meta' &&
        <div className='mt-4 border p-2 border-slate-200'>
          <h6 className='text-[13px] font-[700]'>Meta Info</h6>

          <div className='border mt-2'>

            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Type</h6>
              <h6 className='text-[12px] pl-2'>{state?.campaign_info?.name}</h6>
            </div>
            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Study Medium</h6>
              <h6 className='text-[12px] pl-2'>{state?.campaign_info?.medium_of_study}</h6>
            </div>
            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Name</h6>
              <h6 className='text-[12px] pl-2'>{state?.campaign_info?.student_name}</h6>
            </div>
            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Enter Class</h6>
              <h6 className='text-[12px] pl-2'>{state?.campaign_info?.enter_class}</h6>
            </div>
            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>City of Karnataka Belong To</h6>
              <h6 className='text-[12px] pl-2'>{state?.campaign_info?.which_city_of_karnataka_do_you_belong_to}</h6>
            </div>
            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Full Name</h6>
              <h6 className='text-[12px] pl-2'>{state?.campaign_info?.full_name}</h6>
            </div>
             <div className='flex items-center'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Phone</h6>
              <h6 className='text-[12px] pl-2'>{state?.campaign_info?.phone}</h6>
            </div>
          </div>
        </div>}

        </div>}
        
        {state?._id !== undefined &&
        <div className='bg-[#f5f1eb] mt-4  md:mt-0  xs:max-h-[50vh] md:h-screen w-full'>

       <div className='bg-white p-4 md:flex items-center justify-between border-t md:border-t-0 mb-2'>
        <div>
         <h6 className='font-[12px] md:truncate'>Chat With <span className='font-[800]'>{state?.name}</span></h6>
         <span className='text-[9px]'>Last Client Message : {moment(sessionInfo?.last_message_received?.createdAt).format('LLL')} : <span className='uppercase font-[800]'>{data?.source}</span></span>
         </div>
         <div className='flex items-center'>
          <div className='flex mr-1 items-center rounded-[20px] bg-slate-200 p-1'>
            <MdOutlineTimer size={14} />
            <h6 className='text-[12px] mx-1'>{timeLeft?.hours} : {timeLeft?.minutes}</h6>
          </div>  
          <p className='text-[11px] mr-2'>Current Page : <b>{page}</b> / Total Page : <b>{messages?.pagination?.totalPages}</b> / Total Chat : <b>{messages?.pagination?.total}</b></p> 
          <FiChevronLeft onClick={()=> page != 1 && setpage(page - 1) } size={20} className={`cursor-pointer border mr-1 ${page == 1 && 'opacity-20'} `} />
          <FiChevronRight onClick={()=>page != messages?.pagination?.totalPages && setpage(page + 1)} size={20} className={`cursor-pointer border ${page == messages?.pagination?.totalPages && 'opacity-20'} `} />
         </div>
        </div>    

        <div className="px-4 md:max-h-[75vh] overflow-y-scroll flex flex-col space-y-5">
          {messages?.datas?.map((d) => (
            <div
              key={d?._id}
              className={`flex mb-1 z-10 flex-col max-w-[75%] p-1 rounded shadow-sm relative ${
                d?.chat_type === "SalesUser" ? 'self-end bg-[#d9fdd2]' : 'self-start bg-white'
              }
              ${
                (d?.template_message === 'finalning' || d?.template_message === 'akul1' || d?.template_message === 'final10thclassfollowup') &&  'w-[220px]'
              }

               ${
                d?.template_message === 'welcomemsg11' &&  'w-[155px]'
              }
              
              `}
            >  

            {/* <h6>{d?.template_message}</h6> */}
           
              {['finalning','final10thclassfollowup','akul1','teacherfollowup111','vibhavafinalfollowup','ranjithafollowup','teachersfollowup','nithinfollowup','ningrajfollowup','akulfollowup']?.includes(d?.template_message) &&
              <video
                src={`${d?.mediaUrl}`}
                controls
                width="100%"
                className='min-w-[100px] max-w-[200px]'
                
                style={{ borderRadius: '8px', }}
              />}

              {/* <h6>{d?.mediaUrl}</h6> */}

               {/* {d?.template_message === 'akul1' &&
              <video
                src={`${d?.mediaUrl}`}
                controls
                width="100%"
                style={{ borderRadius: '8px' }}
              />} */}

              {d?.template_message === 'welcomemsg11' &&
              <img src={`${d?.mediaUrl}`} className='w-[150px]' alt="welcomemsg11" />
              }

              {d?.type == 'video' && 
              <video controls className='w-[300px]' src={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.mediaUrl}`} />
              }


              {/* <h6>{d?.mediaUrl}</h6> */}
              {/* <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.mediaUrl}`} className='w-[150px]' alt="welcomemsg11" /> */}


              {d?.type == 'audio' && 
              <AudioPlayer url={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.mediaUrl}`} />}



              {(d?.type == 'document') && 
              <FileDownloadCard
                fileName={d?.mediaUrl?.split('/')[d?.mediaUrl?.split('/')?.length - 1]}
                downloadUrl={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.mediaUrl}`}
              />}

               {(d?.type == 'image') && 
              <ImageDownloadCard
                fileName={d?.mediaUrl?.split('/')[d?.mediaUrl?.split('/')?.length - 1]}
                downloadUrl={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.mediaUrl}`}
              />}

              {(d?.type == 'text' || d?.message !== '') &&
              <h6 className="text-[12px] min-w-[100px] max-w-[200px]  p-1">{d?.message}</h6>}

    {/* {(d?.type == 'text' || d?.message !== '') &&
      <>
    {d?.message?.split('\n').map((line, index) => (
        <h6 className="text-[12px] min-w-[100px]  p-1" key={index}>
          {line}
        </h6>
      ))}
      </>} */}

              <h6 className="text-[8px] inline-block w-max font-bold opacity-60 absolute -bottom-[15px] right-1 text-[#576555]">
                {moment(d?.createdAt).format("lll")}
              </h6>
            </div>
          ))}


          <div className='min-h-[50px]'>

          </div>

          <div ref={messagesEndRef} />

        </div>

        
 
 
          {/* <div className={`bg-white  relative z-40 px-4 border-gray-300 mt-8 md:mt-0 md:absolute bottom-[-7px] mb-2 pb-2 w-[100%]`}>

        
          <div className={`bg-red-100 max-w-[${showEdit ? '67%' : '100%'}] z-40`}>
            <div className='relative flex items-center'>
              <div className='w-[100%]'>
              <TextAreaInput1
                label={'Message'} 
                value={messageInfo?.message}
                handlechange={handleChange1}
                error={messageInfo?.error}
              />
              </div>
              
            <div className='absolute w-[42px] h-[42px] flex items-center justify-center bg-slate-200 right-[1px] top-[26px] flex ml-2'>
              <CgAttachment onClick={()=>!loader && openFilePicker()} size={22} className={` ${loader && 'cursor-disabled'} rounded-full mr-1 hover:bg-slate-200 cursor-pointer p-1`} />
            </div>
             <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
              />

            <h6 onClick={()=>setmodal(true)} className='text-[12px] cursor-pointer p-1 rounded bg-[#de9f19] absolute -bottom-[32px] right-[0px]'>Click To send Template Message</h6>

           <div className='absolute cursor-pointer top-[-6px] right-[0px]  z-40'>
            <div className='flex border mt-2  rounded-[30px] w-max'>
                <h6 onClick={()=>sessionInfo?.session  && setchatType('Session')} className={`${chatType == 'Session' && 'bg-[#de9f19]'} ${!sessionInfo?.session && 'opacity-50 cursor-not-allowed'} overflow-hidden text-center rounded-l-[30px] text-[9px] p-1 w-[50px] font-[800]`}>Session</h6> 
                <h6 onClick={()=>setchatType('Template')} className={`${chatType == 'Template' && 'bg-[#de9f19]'} overflow-hidden text-center rounded-r-[30px] text-[9px] p-1 w-[50px] font-[800]`}>Template</h6> 
            </div>
           </div> 

            </div>

          <div className='mt-2 '>
            <ButtonFilledAutoWidth btnName="Send" onClick={submitMessage} />
          </div>
          </div>
          </div> */}

        <div className="bg-white relative z-40 px-4 border-gray-300 mt-8 md:mt-0 md:absolute bottom-[-7px] mb-2 pb-2 w-full">
          <div className="z-40" style={{ width: showEdit ? "66%" : "100%",minWidth: showEdit ? "66%" : "100%",maxWidth: showEdit ? "66%" : "100%" }}>

            <div className="relative w-[92vw] md:w-auto flex items-start">

              <div className="w-[100%]">
                <TextAreaInput1
                  label="Message"
                  value={messageInfo?.message}
                  handlechange={handleChange1}
                  error={messageInfo?.error}
                />
              </div>

              {sessionInfo?.session && 
              <button
                onClick={() => !loader && openFilePicker()}
                className="absolute right-0 top-[26px] w-[42px] h-[42px] flex items-center justify-center bg-slate-200 rounded"
              >
                <CgAttachment size={15} className={`${loader ? "opacity-50" : ""}`} />
              </button>}

              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
              />

              <div className="absolute top-[2px] right-0 z-40">
                <div className="flex border rounded-[30px] w-max bg-white">
                  <h6
                    onClick={() => sessionInfo?.session && setchatType("Session")}
                    className={`
                      ${chatType === "Session" && "bg-[#de9f19]"}
                      ${!sessionInfo?.session && "opacity-50 cursor-not-allowed"}
                      text-center rounded-l-[30px] text-[9px] px-2 py-1 font-[800]
                    `}
                  >
                    Session
                  </h6>

                  <h6
                    onClick={() => setchatType("Template")}
                    className={`
                      ${chatType === "Template" && "bg-[#de9f19]"}
                      text-center rounded-r-[30px] text-[9px] px-2 py-1 font-[800]
                    `}
                  >
                    Template
                  </h6>
                </div>
              </div>
            </div>

            <h6
              onClick={() => setmodal(true)}
              className="text-[12px] cursor-pointer p-1 rounded bg-[#de9f19] mt-1 w-max ml-auto"
            >
              Click To send Template Message
            </h6>

            <div className="mt-2">
              <ButtonFilledAutoWidth btnName="Send" onClick={submitMessage} />
            </div>
          </div>
        </div>  
        </div>}

      
      </div>

      
      </div> 

    </div>
  )
}

export default ClientListCE